import React from 'react';
import { Outlet } from 'react-router-dom';

const VmsPage = () => <Outlet />;

export default VmsPage;
